<template>
  <div>
    <div>
      <a
        href="https://firebasestorage.googleapis.com/v0/b/propertyfire-80c2e.appspot.com/o/Sample%20Tenant%20Application.pdf?alt=media&token=8b0281aa-69c4-4012-97e0-0bb31e0f6aa7"
        download
      >
        Tenant Application
      </a>
    </div>
    <div>
      <a
        href="https://firebasestorage.googleapis.com/v0/b/propertyfire-80c2e.appspot.com/o/PARKING-LEASE-AGREEMENT.pdf?alt=media&token=b62f5f5c-50d6-40de-bf98-df94d2c4a771"
        download
      >
        Parking Agreement
      </a>
      <div>
        <a
          href="https://firebasestorage.googleapis.com/v0/b/propertyfire-80c2e.appspot.com/o/leaseagreement.pdf?alt=media&token=7a2765cd-7f8c-4c13-b18d-bce503cfa104"
          download
        >
          Lease Agreement
        </a>
      </div>
      <a
        href="https://firebasestorage.googleapis.com/v0/b/propertyfire-80c2e.appspot.com/o/-LShIs-DWiDrUdtS2B_T?alt=media&token=21dffbe9-57a6-4a17-922b-5f91809fb860"
        download
      >
        Noise Complaint I
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style>
</style>
